import * as React from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

type Props = {
  roleName: string;
};

const CurrentlyHiringNotification: React.VFC<Props> = ({ roleName }) => {
  return (
    <InlineNotification
      severity="information"
      title={_t('Get discovered by recruiters using Coursera Hiring Solutions')}
    >
      {_t(
        'Coursera has partnered with industry-leading companies with open entry-level #{roleName} positions. After you complete your profile, you can showcase your skills to recruiters who are hiring for this role.',
        { roleName }
      )}
    </InlineNotification>
  );
};

export default CurrentlyHiringNotification;
